import {observer} from 'mobx-react';
import Celebration from './Celebration';
import {FormattedMessage} from 'react-intl';

const FirstDay = observer(({firstDay, emojiReady}) => {
  return (
    <Celebration
      employee={firstDay.employee}
      date={firstDay.publishedAt}
    >
      <FormattedMessage
        id='hr_dashboard.feed.celebrations.FIRST_DAY_MESSAGE'
        values={{
          link: <a href={`/employees/${firstDay.employee.id}`}>
                  {firstDay.employee.name}
                </a>
        }}
      />
      {emojiReady && <span className='ml1'>
        <em-emoji className='emoji-icon' id='wave' set='native' size='22px'></em-emoji>
      </span>}
    </Celebration>
  );
});

export default FirstDay;
